export default __webpack_public_path__ + "static/media/kalahastiDeitie1.a5dc500b.png";